module.exports = __webpack_public_path__ + "img/entranceBg.8b596adf.png";